import { cn, Select, SelectItem, Tab, Tabs } from '@heroui/react';

type Props = {
  options: { key: string; title: string }[];
  tab: string;
  setTab: (tab: string) => void;
  forceHorizontal?: boolean;
};

export default function ResponsiveTabs({ options, tab, setTab, forceHorizontal }: Props) {
  const showSelectAtSmallScreenSizes = options.length > 4;
  return (
    <>
      <Tabs
        color='default'
        variant='solid'
        classNames={{
          tabList: cn('self-end flex-row md:flex-col', {
            '!flex-row': forceHorizontal,
            'hidden md:flex': showSelectAtSmallScreenSizes,
          }),
          tab: cn('justify-end', {
            'text-xs px-1 mx-0 md:text-sm md:px-2': options.length > 4,
          }),
        }}
        aria-label='Tabs'
        selectedKey={tab}
        onSelectionChange={key => setTab(key as string)}
      >
        {options.map(tab => (
          <Tab key={tab.key} title={tab.title} />
        ))}
      </Tabs>
      {showSelectAtSmallScreenSizes && (
        <Select
          size='lg'
          classNames={{
            value: '!font-bold text-primary-900',
            base: cn({
              hidden: !showSelectAtSmallScreenSizes,
              'block md:hidden': showSelectAtSmallScreenSizes,
            }),
          }}
          selectedKeys={[tab]}
          variant='flat'
          color='primary'
          onSelectionChange={keys => setTab(keys.currentKey as string)}
        >
          {options.map(animal => (
            <SelectItem key={animal.key}>{animal.title}</SelectItem>
          ))}
        </Select>
      )}
    </>
  );
}
